<template>
  <div style="padding: 0 10px">
    <div style="text-align: left">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        @keydown.native.enter="submit"
      >
        <el-form-item label="拣货批次">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.batchCode"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="批次包编号">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.pkgCode"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.platformOrderNo"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            placeholder="任务状态"
            @change="submit"
            v-model="formInline.pickStatus"
          >
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="未完成" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标记">
          <el-select
            placeholder="请选择"
            v-model="formInline.explosiveProductTag"
          >
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="爆品" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="" type="primary" @click="submit">查询</el-button>
          <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: left; margin-bottom: 4px;">
      <el-button type="primary" @click="toCreateWave">新建波次</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :hasHeader="false"
      :isPagination="query"
      rowKey="waveCode"
      isExpanded_hidden
    >
      <div slot="action" slot-scope="{ record }">
        <el-button type="text" @click="checkWave(record)">查看条件</el-button>
      </div>
      <template slot="expandedRender" slot-scope="{ record,son_width,targetLeft }">
        <WmsTable
          :hasHeader="false"
          :isPagination="false"
          :dataSource="record.deliveryWaveBatchList || []"
          :columns="pkgColumns"
        >
          <div slot="action" slot-scope="{ record }">
            <el-button type="text" @click="checkBatchDetail(record)">查看详情</el-button>
          </div>
          <template #batchCode="{ record }">
            {{ record.batchCode }}
            <div >
              <el-tag v-if="record.explosiveProductTag === 1" size="mini" type="danger">爆品</el-tag>
               <el-tag v-if="record.tiktokTag == 1" size="mini" type="danger">Tiktok</el-tag>
            </div>
          </template>
        </WmsTable>
      </template>
    </WmsTable>
    <waveOptions ref="waveOptions" @refresh="getList"></waveOptions>
    <pickDetail ref="pickDetail"></pickDetail>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import waveOptions from "./components/waveOptions.vue";
import pickDetail from "./components/pickDetail.vue"
import { columns, pkgColumns } from "./data";
import { wavePage, waveDetail, getPickByBatchCode } from "@/apis/outStock";
export default {
  title: "波次管理",
  name: "waves",
  components: { WmsTable, waveOptions, pickDetail },
  props: {},
  data() {
    return {
      formInline: {},
      columns,
      pkgColumns,
      dataSource: [],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },

  created() {},
  mounted() {
    this.getList();
  },

  methods: {
    submit() {
      this.query.current = 1;
      this.getList();
    },
    rest() {
      this.date = null;
      Object.keys(this.formInline).forEach((i) => {
        this.formInline[i] = undefined;
      });
      this.query = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.getList();
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    getList() {
      wavePage({
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline
      }).then((res) => {
        this.dataSource = res.data.records
        this.query.total = res.data.total
      });
    },
    toCreateWave(){
      this.$refs.waveOptions.open()
    },
    checkWave(record){
      waveDetail({waveCode: record.waveCode}).then(res=> {
        if(res.code == 0){
          this.$refs.waveOptions.open({
            ...res.data
          })
        }
      })
    },
    checkBatchDetail(record){
      this.$refs.pickDetail.open(record.batchCode)
      // getPickByBatchCode({
      //   record.
      // })
    }
  },
};
</script>

<style scoped lang="less"></style>
